var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9281 28C45.9281 37.9014 37.9014 45.9281 28 45.9281C18.0986 45.9281 10.0719 37.9014 10.0719 28C10.0719 18.0986 18.0986 10.0719 28 10.0719C37.9014 10.0719 45.9281 18.0986 45.9281 28ZM42.2002 52.1372C38.0368 54.5918 33.1829 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 34.1992 53.9854 39.928 50.5751 44.5671L64.0492 58.0413C66.2508 60.2428 66.2508 63.8122 64.0492 66.0137C61.8477 68.2153 58.2783 68.2153 56.0767 66.0137L42.2002 52.1372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.cd820f5a55f7cd57d7131f1672d43473.svg";
export { ForwardRef as ReactComponent };